import { makePostRequest, makeGetRequest } from "@services/RequestService";
import { API_ROUTES } from "@utils/Utils";
import { CMS_PORT, QA_PORT, SERVICE_PORT } from "@utils/baseURL";
import { handleApiResponse } from "@services/CommonResponse";
import {
  LoginVerificationDataModel,
  LoginVerificationDataModelBuilder,
} from "@models/userModule/LoginVerificationDataModel";

export async function verifyLoginToken(
  token: string,
): Promise<LoginVerificationDataModel> {
  return handleApiResponse({
    url: CMS_PORT + API_ROUTES.LOGIN_VERIFICATION,
    apiCallFunction: makePostRequest,
    convertResponseDataFunction:
      convertResponseDataToLoginVerificationDataModel,
    data: { token },
  });
}

export async function verifyLoginTokenRGS(
  token: string,
): Promise<LoginVerificationDataModel> {
  return handleApiResponse({
    url: SERVICE_PORT + API_ROUTES.LOGIN_VERIFICATION,
    apiCallFunction: makePostRequest,
    convertResponseDataFunction:
      convertResponseDataToLoginVerificationDataModel,
    data: { token },
  });
}

export async function verifyLoginTokenCMS(
  token: string,
): Promise<LoginVerificationDataModel> {
  return handleApiResponse({
    url: QA_PORT + API_ROUTES.CMS_LOGIN_VERIFICATION,
    apiCallFunction: makePostRequest,
    convertResponseDataFunction:
      convertResponseDataToLoginVerificationDataModel,
    data: { token },
  });
}

export async function getUserGroupData(userGroupId: string): Promise<any> {
  return handleApiResponse({
    url: CMS_PORT + API_ROUTES.GET_USER_BY_GROUP_ID,
    apiCallFunction: makeGetRequest,
    convertResponseDataFunction: (data) => data,
    data: { userGroupId },
  });
}

export async function verifyAuthMe(): Promise<any> {
  return handleApiResponse({
    url: CMS_PORT + API_ROUTES.AUTH_ME,
    apiCallFunction: makeGetRequest,
    convertResponseDataFunction: (data) => data,
  });
}

export async function verifyAuthMeRGS(): Promise<any> {
  return handleApiResponse({
    url: SERVICE_PORT + API_ROUTES.AUTH_ME,
    apiCallFunction: makeGetRequest,
    convertResponseDataFunction: (data) => data,
  });
}

export async function logout(): Promise<any> {
  return handleApiResponse({
    url: CMS_PORT + API_ROUTES.LOGOUT,
    apiCallFunction: makePostRequest,
    convertResponseDataFunction: (data) => data,
  });
}

function convertResponseDataToLoginVerificationDataModel(
  data: any,
): LoginVerificationDataModel {
  return new LoginVerificationDataModelBuilder()
    .setAuthUserId(data.authUserId)
    .setCompanyId(data.companyId)
    .setCompanyUserId(data.companyUserId)
    .setContactInfo(data.contactInfo)
    .setDateCreate(data.dateCreate)
    .setDateModified(data.dateModified)
    .setIsActive(data.isActive)
    .setLanguage(data.language)
    .setToken(data.token)
    .setTokenIsValid(data.tokenIsValid)
    .setTokenexpires(data.tokenexpires)
    .setUserGroupId(data.userGroupId)
    .setUserMetaData(data.userMetaData)
    .build();
}
